import { StarPlusIcon } from '../icons'
import { twMerge } from 'tailwind-merge'
import { useIntl } from 'react-intl'
import PrimaryTooltip from 'app/componentV4/Tooltip/PrimaryTooltip'
import { isEmpty } from 'ramda'

export default function GenerateWithAIButton(props) {
  const { text = '' } = props
  const { formatMessage } = useIntl()
  const title = isEmpty(text)
    ? formatMessage({
        id: 'ai.generateWithAI.button',
      })
    : text

  return (
    <PrimaryTooltip title={title}>
      <button
        type="button"
        {...props}
        className={twMerge(
          'w-32 h-32 m-auto flex items-center justify-center text-white rounded-5 cursor-pointer',
          !props.disabled
            ? 'bg-secondary hover:bg-secondary-200'
            : 'bg-gray-300',
          props.className,
        )}
      >
        <StarPlusIcon />
      </button>
    </PrimaryTooltip>
  )
}
